var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('groups-list',{staticClass:"mb-4",attrs:{"input-customer-id":_vm.customerId,"input-group-id":_vm.groupId}}),_c('endpoints-list',{attrs:{"input-customer-id":_vm.customerId,"input-endpoint-id":_vm.endpointId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }